<template>
  <div class="brand-suggested-brand-item_wrapper brand-item">
    <div class="brand-suggested-brand-item_banner-wrapper">
      <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
        <img
          class="brand-suggested-brand-item_banner"
          width="251"
          height="142"
          v-lazy="_companyBanner(brand.banner_shop[Object.keys(brand.banner_shop)[0]])"
          :alt="brand.company"
        />
      </router-link>
    </div>
    <div class="brand-suggested-brand-item_body dosiin_mb-4">
      <div class="brand-item_img-wrapper brand-suggested-brand-item_img-wrapper">
        <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
          <img
            class="brand-suggested-brand-item_img"
            v-lazy="_companyAvatar(brand.logos.theme)"
            :alt="brand.company"
          />
        </router-link>
      </div>
      <div class="brand-suggested-brand-item_info">
        <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
          <h5
            class="brand-item_title truncate-brand-suggested"
            v-text="brand.company"
          ></h5>
        </router-link>
        <dl class="brand-item_social">
          <dd>
            <strong>{{ brand.follow_count }}</strong> người theo dõi
          </dd>
          <dd>
            <strong>{{ brand.products_count ? brand.products_count : 0 }}</strong> sản
            phẩm
          </dd>
        </dl>
      </div>
    </div>
    <div class="brand-suggested-brand-item_follow">
      <FollowButton
        @update:modelValue="(newValue) => (brand.follow_count = newValue)"
        class="brand_follow-btn dosiin_brand_follow-btn primary-button button follow-with-text-btn"
        followable_type="brand"
        :followable_id="brand.company_id"
        :is_follow="brand.is_follow"
      />
      <router-link
        :to="_brandUrl(brand.seo_name)"
        :title="brand.company"
        class="brand-visit-btn"
      >
        <div class="inner-btn">
          <svg
            class="icon icon-visit-store"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.36666 13.2695V7.06321C1.50177 7.10333 1.64668 7.12591 1.79995 7.12591C2.22967 7.12591 2.62217 6.97158 2.93248 6.72162C3.24279 6.97158 3.6353 7.12591 4.06502 7.12591C4.49474 7.12591 4.88725 6.97158 5.19755 6.72162C5.50786 6.97158 5.90037 7.12591 6.33009 7.12591C6.7747 7.12591 7.15274 6.93304 7.46263 6.67065C7.77251 6.93304 8.15055 7.12591 8.59516 7.12591C9.03976 7.12591 9.41781 6.93314 9.7277 6.67066C10.0376 6.93314 10.4156 7.12591 10.8602 7.12591C11.2896 7.12591 11.6825 6.97197 11.9928 6.72224C12.303 6.97197 12.6959 7.12591 13.1253 7.12591C13.2786 7.12591 13.4235 7.10333 13.5586 7.06321V8.01613L13.5744 8.03147C13.9261 8.37351 14.1579 8.84007 14.1977 9.3604L14.2014 9.40851H14.3099V6.52171C14.5483 6.16833 14.6335 5.73079 14.6335 5.28034C14.6335 4.41087 14.3329 2.9142 14.3099 2.8008V1.53034C14.3099 0.965556 13.8485 0.5 13.2871 0.5H1.63816C1.07673 0.5 0.61533 0.965556 0.61533 1.53034V2.80079C0.592337 2.91419 0.291748 4.41086 0.291748 5.28034C0.291748 5.73079 0.376954 6.16833 0.61533 6.52171V13.2695C0.61533 13.8372 1.07381 14.2998 1.63816 14.2998H8.18016L8.23806 13.5435H1.63816C1.48897 13.5435 1.36666 13.4211 1.36666 13.2695ZM5.19136 2.45208C5.17466 2.45244 5.15801 2.45393 5.14151 2.45652H1.36666V1.53034C1.36666 1.37448 1.48447 1.25634 1.63816 1.25634H13.2871C13.4408 1.25634 13.5586 1.37448 13.5586 1.53034V2.45652H9.78619C9.74847 2.4507 9.71008 2.4507 9.67236 2.45652H7.52112C7.4834 2.4507 7.44501 2.4507 7.40729 2.45652H5.25167C5.23201 2.45345 5.21214 2.45196 5.19223 2.45206L5.19136 2.45208ZM9.10455 10.0086L8.75695 14.5611L9.0818 10.3099L9.10455 10.0086ZM9.05625 9.95652L9.02987 10.3059L8.70487 14.5591V14.5738C8.70487 15.1386 9.16627 15.6042 9.7277 15.6042H14.5814C15.1428 15.6042 15.6042 15.1386 15.6042 14.5738V14.5591L15.2528 9.95652H13.6628V9.51947C13.6628 8.68453 12.9841 8 12.1546 8C11.3251 8 10.6464 8.68453 10.6464 9.51947V9.95652H9.05625ZM1.96174 1.47826C1.86198 1.47826 1.76638 1.5182 1.69596 1.58917C1.62556 1.66012 1.58607 1.75626 1.58607 1.85643C1.58607 1.9566 1.62556 2.05274 1.69596 2.1237C1.76638 2.19466 1.86198 2.2346 1.96174 2.2346C2.0615 2.2346 2.1571 2.19466 2.22752 2.1237C2.29792 2.05274 2.3374 1.9566 2.3374 1.85643C2.3374 1.75626 2.29792 1.66012 2.22752 1.58917C2.1571 1.5182 2.0615 1.47826 1.96174 1.47826ZM2.93248 1.47826C2.83272 1.47826 2.73713 1.5182 2.66671 1.58917C2.5963 1.66012 2.55682 1.75626 2.55682 1.85643C2.55682 1.9566 2.5963 2.05274 2.66671 2.1237C2.73713 2.19466 2.83272 2.2346 2.93248 2.2346C3.03225 2.2346 3.12784 2.19466 3.19826 2.1237C3.26867 2.05274 3.30815 1.9566 3.30815 1.85643C3.30815 1.75626 3.26867 1.66012 3.19826 1.58917C3.12784 1.5182 3.03225 1.47826 2.93248 1.47826ZM3.90323 1.47826C3.80347 1.47826 3.70787 1.5182 3.63745 1.58917C3.56705 1.66012 3.52756 1.75626 3.52756 1.85643C3.52756 1.9566 3.56705 2.05274 3.63745 2.1237C3.70787 2.19466 3.80347 2.2346 3.90323 2.2346C4.00299 2.2346 4.09859 2.19466 4.16901 2.1237C4.23941 2.05274 4.27889 1.9566 4.27889 1.85643C4.27889 1.75626 4.23941 1.66012 4.16901 1.58917C4.09859 1.5182 4.00299 1.47826 3.90323 1.47826ZM1.31542 3.21992L1.31675 3.21286H2.55682V6.03963C2.36011 6.24173 2.09858 6.36957 1.79995 6.36957C1.64819 6.36957 1.53887 6.34491 1.45341 6.30082C1.36826 6.25689 1.30246 6.19143 1.2412 6.10235C1.12035 5.92661 1.04308 5.63525 1.04308 5.28034C1.04308 4.67408 1.24751 3.58252 1.31542 3.21992L1.31542 3.21992ZM3.30815 3.21286H4.82189V6.03963C4.62518 6.24173 4.36365 6.36957 4.06502 6.36957C3.76639 6.36957 3.50486 6.24173 3.30815 6.03963V3.21286ZM5.57322 3.21286H7.08696V6.02586C6.88908 6.23279 6.6307 6.36957 6.33009 6.36957C6.02948 6.36957 5.7711 6.23279 5.57322 6.02586V3.21286ZM7.83829 3.21286H9.35203V6.02587C9.15443 6.23262 8.89577 6.36957 8.59516 6.36957C8.29455 6.36957 8.03617 6.23279 7.83829 6.02586V3.21286ZM10.1034 3.21286H11.6171V6.02587C11.4195 6.23262 11.1608 6.36957 10.8602 6.36957C10.5596 6.36957 10.301 6.23262 10.1034 6.02587V3.21286ZM12.3684 3.21286H13.6085L13.6098 3.21992C13.6777 3.58251 13.8822 4.67408 13.8822 5.28034C13.8822 5.63525 13.8049 5.92661 13.684 6.10235C13.6228 6.19143 13.557 6.25689 13.4718 6.30082C13.3864 6.34491 13.2771 6.36957 13.1253 6.36957C12.8267 6.36957 12.5649 6.24158 12.3684 6.03964V3.21286ZM12.1546 8.75634C12.576 8.75634 12.9114 9.09376 12.9114 9.51947V9.95652H11.3977V9.51947C11.3977 9.09376 11.7331 8.75634 12.1546 8.75634ZM9.45684 14.5769L9.75194 10.7129H14.5572L14.8523 14.5769C14.8506 14.7313 14.7338 14.8478 14.5814 14.8478H9.7277C9.57529 14.8478 9.45852 14.7313 9.45684 14.5769Z"
              fill="url(#paint_linear)"
            ></path>
            <defs>
              <linearGradient
                id="paint_linear"
                x1="0.291748"
                y1="0.5"
                x2="15.3945"
                y2="15.8111"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#ED55C7"></stop>
                <stop offset="1" stop-color="#6756CA"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    brand: {
      type: Object,
      require: true,
    },
    setup(props) {
      return {
        ...props,
      };
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 1440px) {
  .swiper-slide
    .brand-suggested-brand-item_wrapper
    .brand-suggested-brand-item_banner-wrapper
    a {
    height: 150px !important;
  }
}

.brand-suggested-brand-item_wrapper .brand-suggested-brand-item_banner-wrapper a {
  height: 175px;
  display: block;
}

.brand-suggested-brand-item_wrapper .brand-suggested-brand-item_banner-wrapper img {
  height: 100%;
}
</style>
